import React from "react";
import CircleOutlinedIcon from "@mui/icons-material/CircleOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Grid, Typography } from "@mui/material";
import { DRxTheme, RxChangeRequestedCard } from "../../Theme";
import { prescriptionForms } from "../../constants/RxChangeAlerts/rxChangeAlerts";

interface Props {
  row: any;
  medRequestSelectedData: any;
  getValuesOfDropDown: any;
  setMedRequestSelectedData: any;
  handleHideMedRequestPopupClick: any;
}

function MedicationRequestedList(props: Props) {
  const {
    row,
    medRequestSelectedData,
    getValuesOfDropDown,
    setMedRequestSelectedData,
    handleHideMedRequestPopupClick,
  } = props;
  return (
    <RxChangeRequestedCard sx={{ padding: "16px !important" }}>
      <Grid container>
        <Grid item xs={3} md={3}>
          <Typography component={"span"} variant={"body2"}>
            <strong>Drug Name</strong>
          </Typography>
        </Grid>
        <Grid item xs={8} md={8}>
          <Typography component={"span"} variant={"body2"}>
            :{row.drugDescription ? row.drugDescription : "N/A"}
          </Typography>
        </Grid>
        <Grid
          item
          xs={1}
          md={1}
          display={"flex"}
          justifyContent={"flex-end"}
          sx={{
            cursor: "pointer",
          }}
        >
          {medRequestSelectedData?.drugID !== row?.drugID ? (
            <CircleOutlinedIcon
              sx={{
                color: `${DRxTheme.palette.primary.main}`,
              }}
              onClick={() => {
                const substitutionName = getValuesOfDropDown(
                  row?.substitutionCodeOptions,
                  row?.substitutionCode
                );
                setMedRequestSelectedData({
                  ...row,
                  reasonDenied: "0",
                  substitutionName,
                });
                setTimeout(() => {
                  handleHideMedRequestPopupClick();
                }, 300);
              }}
            />
          ) : (
            <CheckCircleIcon
              sx={{
                color: `${DRxTheme.palette.primary.main}`,
                // color: "#0C585B"
              }}
            />
          )}
        </Grid>
        <Grid item xs={3} md={3}>
          <Typography component={"span"} variant={"body2"}>
            <strong>SIG</strong>
          </Typography>
        </Grid>
        <Grid item xs={9} md={9}>
          <Typography
            component={"span"}
            variant={"body2"}
            sx={{
              wordBreak: "break-all",
            }}
          >
            :{row.sig ? row.sig : "N/A"}
          </Typography>
        </Grid>
        <Grid item xs={3} md={3}>
          <Typography component={"span"} variant={"body2"}>
            <strong>Quantity</strong>
          </Typography>
        </Grid>
        <Grid item xs={3} md={3}>
          <Typography component={"span"} variant={"body2"}>
            :
            {[null, ""].includes(row?.quantity) &&
            [null, ""].includes(row?.qtyQualifier)
              ? "N/A"
              : `${row?.quantity ?? "N/A"}  ${
                  row?.quantity && row?.quantityQualifer
                    ? prescriptionForms[row?.quantityQualifer]
                    : ""
                }`}
          </Typography>
        </Grid>
        <Grid item xs={2} md={2}>
          <Typography component={"span"} variant={"body2"}>
            <strong>Refiils</strong>
          </Typography>
        </Grid>
        <Grid item xs={3} md={3}>
          <Typography component={"span"} variant={"body2"}>
            :{row.refills ? row.refills : "N/A"}
          </Typography>
        </Grid>
        <Grid item xs={3} md={3}>
          <Typography component={"span"} variant={"body2"}>
            <strong>Substitution</strong>
          </Typography>
        </Grid>
        <Grid item xs={9} md={9}>
          <Typography component={"span"} variant={"body2"}>
            :{row.substitutionName ? row.substitutionName : "N/A"}
          </Typography>
        </Grid>
        <Grid item xs={3} md={3}>
          <Typography component={"span"} variant={"body2"}>
            <strong>Notes</strong>
          </Typography>
        </Grid>
        <Grid item xs={9} md={9}>
          <Typography component={"span"} variant={"body2"}>
            :{row.pharmacyNote ? row.pharmacyNote : "N/A"}
          </Typography>
        </Grid>
      </Grid>
    </RxChangeRequestedCard>
  );
}

export default MedicationRequestedList;
